import { spawn } from 'redux-saga/effects';

// import logTrackingQueue from './logTrackingQueue';
import { authFlow, refreshProfileFlow } from './authentication';
import { logoutFlow } from './logout';
import { unsubscribeFlow } from './unsubscribe';
import { fetchProductSubscriptionsFlow } from './productSubscriptions';
import { syncExpireSoonPackageSubscriptionsFlow } from './readExpireSoonPackageSubscriptions';
import { fetchFavoriteDramasFlow, addFavoriteDramaFlow, removeFavoriteDramaFlow } from './favoriteDrama';
import { trackingProfileFlow } from './tracking';
import { fetchSummaryFlow } from './summary';
import { fetchCategoryFlow } from './dramaCategory';
import { fetchPoliciesFlow, updatePoliciesFlow } from './policy';

import {
  fetchWatchHistoryFlow,
  updateWatchHistoryFlow,
  deleteWatchHistoryFlow,
  deleteAllWatchHistoryFlow,
} from './watchHistory';

export default function* root() {
  // yield spawn(logTrackingQueue);
  yield spawn(trackingProfileFlow);

  yield spawn(unsubscribeFlow);
  yield spawn(fetchProductSubscriptionsFlow);
  yield spawn(syncExpireSoonPackageSubscriptionsFlow);

  yield spawn(fetchFavoriteDramasFlow);
  yield spawn(addFavoriteDramaFlow);
  yield spawn(removeFavoriteDramaFlow);

  yield spawn(fetchWatchHistoryFlow);
  yield spawn(updateWatchHistoryFlow);
  yield spawn(deleteWatchHistoryFlow);
  yield spawn(deleteAllWatchHistoryFlow);

  yield spawn(logoutFlow);
  yield spawn(authFlow);
  yield spawn(refreshProfileFlow);

  yield spawn(fetchSummaryFlow);
  yield spawn(fetchCategoryFlow);

  yield spawn(fetchPoliciesFlow);
  yield spawn(updatePoliciesFlow);
}
